import { useFormContext } from 'react-hook-form';
import { HookReactSingleSelect } from '@/components/UI/HookForm/Form/ReactSelect';
import type { UserOption } from '@/types/Constants';
import type { InternalTeam } from '@/types/Project';

export function SupportSelect({ internalTeam }: { internalTeam?: InternalTeam[] }) {
  const { watch } = useFormContext();
  const lead = watch('lead');

  const options = internalTeam?.filter((member) => member.id !== lead?.id);

  return (
    <HookReactSingleSelect
      id='support'
      options={options}
      getOptionLabel={(option) => (option as UserOption).name}
      getOptionValue={(option) => (option as UserOption).id.toString()}
      placeholder='Select Support'
      name='support'
      label='Support'
      isClearable
    />
  );
}
